import React from "react";

// Material UI
import { Container, Grid, Card, CardContent, Typography, TextField, Button, Box, InputLabel, Alert } from '@mui/material';

// Material UI Icons
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

// Images
import logoLightFull from "../../assets/images/logo-light-full.png";
import authEffect2 from "../../assets/images/effect-pattern/auth-effect-2.png";
import authEffect from "../../assets/images/effect-pattern/auth-effect.png";

// Router
import { Link } from "react-router-dom";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunk";
import { Colortheme } from "../comman";


const ForgetPassword = (props: any) => {

    document.title = "Reset Password | Rudrix";
    const dispatch: any = useDispatch();
    const {bodycolor,white75, bodytheme, textmuted, primary } = Colortheme();

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
        }),
        onSubmit: (values) => {
            dispatch(userForgetPassword(values, props.history));
        }
    });


    const selectLayoutState = (state: any) => state.ForgetPassword;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (state) => ({
            forgetError: state.forgetError,
            forgetSuccessMsg: state.forgetSuccessMsg,
        })
    );
    // Inside your component
    const {
        forgetError, forgetSuccessMsg
    } = useSelector(selectLayoutProperties);

    return (
        <React.Fragment>
            <section style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: bodytheme }}>
                <Container maxWidth={false}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={7}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} lg={5}>
                                            <Card sx={{ backgroundColor: primary, height: '100%', border: 'none', boxShadow: 'none', padding: '0.75rem', overflow: 'hidden', marginBottom: 0 }}>
                                                <CardContent sx={{ height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                                                    <Box style={{ marginBottom: "12px", position: 'relative', display: 'flex' }}>
                                                        <img src={logoLightFull} alt="rudrix" height="26" />
                                                        <img src={authEffect2} alt="rudrix" style={{ top: '-27px', transform: 'rotate(-45deg)', position: 'relative', width: '245px', left: '32px' }} />
                                                        <img src={authEffect} alt="rudrix" style={{ position: 'relative', right: '393px', top: '-99px' }} />
                                                        <img src={authEffect} alt="rudrix" style={{ position: 'relative', right: '308px', top: '313px' }} />
                                                    </Box>
                                                    <Box sx={{ position: 'relative', bottom: '24%' }}>
                                                        <Typography variant="h5" style={{ color: 'white' }}>Start your journey with us.</Typography>
                                                        <Typography variant="body2" sx={{ fontSize: 15, color: white75 }}>
                                                            It brings together your tasks, projects, timelines, files and more
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ textAlign: 'center', color: white75 }}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                                                            <Typography variant="body2" sx={{ display: 'flex' }} margin={0}>
                                                                ©{new Date().getFullYear()} Rudrix. All rights reserved.
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        <Grid item xs={12} lg={7}>
                                            <Card sx={{ margin: 0, border: 0 }} elevation={0}>
                                                <CardContent sx={{ padding: '28px' }}>
                                                    <Box style={{ textAlign: 'center', marginTop: '8px', padding: '24px' }}>
                                                        <Typography variant="h6" color={primary} fontSize={20}>Forgot Password?</Typography>
                                                        <Typography variant="body2" color={textmuted}>Reset password with Rudrix</Typography>
                                                        <EmailOutlinedIcon color="error" sx={{ width: '56px', height: '80px', marginY: '1.5rem' }} />
                                                    </Box>


                                                    {forgetError && forgetError ? (
                                                        <Alert severity="error" sx={{ textAlign: 'center', marginBottom: '0.5rem', marginX: '0.5rem' }}>
                                                            {forgetError}
                                                        </Alert>
                                                    ) : null}
                                                    {forgetSuccessMsg ? (
                                                        <Alert severity="success" sx={{ textAlign: 'center', marginBottom: '0.5rem', marginX: '0.5rem' }}>
                                                            {forgetSuccessMsg}
                                                        </Alert>
                                                    ) : <Alert severity="warning" sx={{ textAlign: 'center', marginBottom: '0.5rem', marginX: '0.5rem' }}>
                                                        Enter your email and instructions will be sent to you!
                                                    </Alert>}

                                                    <Box style={{ padding: '8px', marginTop: '20px' }}>
                                                        <form onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}>
                                                            <Box style={{ marginBottom: '12px' }}>
                                                                <InputLabel htmlFor="email" >Email</InputLabel>
                                                                <TextField fullWidth variant="outlined" placeholder="Enter Email" name="email"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.email || ""}
                                                                    error={
                                                                        validation.touched.email && validation.errors.email ? true : false
                                                                    }
                                                                    helperText={validation.touched.email && validation.errors.email ? validation.errors.email : false}
                                                                />
                                                            </Box>

                                                            <Box style={{ marginTop: '16px' }}>
                                                                <Button variant="contained" color="primary" fullWidth type="submit">
                                                                    Send Reset Link
                                                                </Button>
                                                            </Box>


                                                        </form>

                                                        <Box style={{ textAlign: 'center', marginTop: "25px", marginBottom: '25px' }}>
                                                            <Typography variant="body2" color={bodycolor}>
                                                                Wait, I remember my password...{' '}

                                                                <Link to="/auth-signup-basic" style={{ fontWeight: 'bold', color: 'primary', textDecoration: 'underline' }}>
                                                                    Click here
                                                                </Link>
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default withRouter(ForgetPassword);
